export const removeEmptyProperties = (obj) => Object.fromEntries(Object.entries(obj).filter(([, v]) => v != null))
